import { AUTH_USER } from 'constants/AuthConstant';

// Único punto que limpia la sesión del lado de la UI (localStorage.user +
// Redux). Lo llama el cableado de eventos de authClient (auth/sesionRedux.js)
// ante `revoked` y `guest`, y el thunk signOut. El token no se toca aquí: vive
// en memoria dentro de authClient y lo borra él.
//
// El import del store es dinámico a propósito: utils/axios-request.js importa
// este helper indirectamente, y el store termina importando axios-request.js
// (vía services/rest/*.js -> services/rest/config.js -> utils/axios-request.js).
// Un `import store from '../store'` estático aquí formaría un ciclo de imports
// ("can't access lexical declaration before initialization").
let loggingOut = false;

export async function forceLogout() {
  if (loggingOut) return;
  loggingOut = true;

  localStorage.removeItem(AUTH_USER);

  try {
    const [{ default: store }, { signOutSuccess }] = await Promise.all([
      import('../store'),
      import('../store/slices/authSlice'),
    ]);
    store.dispatch(signOutSuccess());
  } finally {
    loggingOut = false;
  }
}
